<script lang="ts">
	import { getCataloguePath } from "@core/schema/paths/getCataloguePath.js";
	import image from "../assets/photos/image.png?webp&w=569&imagetools";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import Formatted from "./common/Formatted.svelte";
	import Link from "./common/Link.svelte";
	import Media from "./common/Media.svelte";
	import TextWithIcon from "./common/TextWithIcon.svelte";
	import { ButtonVariant } from "./common/getButtonClass.js";

	const {
		heading,
		text,
		buttonText,
		bgColor,
	}: {
		heading: string;
		text: string;
		buttonText: string;
		bgColor?: string;
	} = $props();

	const { tenant } = getGlobalTemplateProps();
</script>

<section class="full-width grid-container {bgColor ? bgColor : ''}">
	<div class="container-center flex items-center flex-col gap-8 sm:gap-10 md:gap-11 lg:gap-[5.5rem]">
		<h2 class="hidden md:inline-block lg:hidden xl:text-center"><Formatted text={heading} /></h2>
		<div class="flex flex-col-reverse xl:grid xl:grid-cols-2 gap-6 sm:gap-8 md:gap-2 w-full">
			<Media
				height={548}
				width={569}
				alt={heading}
				class="sm:hidden xl:block"
				source={{ src: image, type: "image/png" }}
			/>
			<div class="flex flex-col md:hidden lg:flex gap-6 sm:gap-8 lg:gap-10">
				<h2 class="text-left"><Formatted text={heading} /></h2>
				<p class="font-normal text-sm sm:text-base lg:text-lg/[1.4] text-optical-black">
					<Formatted {text} />
				</p>
				<div class="xl:block hidden mt-4 sm:mt-6">
					<Link href={getCataloguePath(tenant.locale)} variant={ButtonVariant.OutlinedWithIcon}
						><TextWithIcon>{buttonText}</TextWithIcon></Link
					>
				</div>
			</div>
			<p
				class="font-medium text-sm sm:text-base md:text-md/[1.35] lg:text-lg/[1.4] text-optical-black hidden md:block lg:hidden md:text-left text-center"
			>
				<Formatted {text} />
			</p>
		</div>
		<div class="xl:hidden flex w-full justify-start">
			<Link href={getCataloguePath(tenant.locale)} variant={ButtonVariant.OutlinedWithIcon}
				><TextWithIcon>{buttonText}</TextWithIcon></Link
			>
		</div>
	</div>
</section>
